import { render, staticRenderFns } from "./VesselDocumentsFormBlock.vue?vue&type=template&id=ea83aedc&"
import script from "./VesselDocumentsFormBlock.vue?vue&type=script&lang=js&"
export * from "./VesselDocumentsFormBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports